export enum IssueStatuses {
  None = '',
  OnHold = 'Flagged',
  Resolved = 'Resolved',
  Unresolved = 'Unresolved',
  NewIssue = 'New Issue',
}
